var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-topic",class:'v-' + _vm.page_name},[_c('Header',{attrs:{"overlayEnable":true}}),_c('router-view'),_c('div',{staticClass:"p-topic-footer"},[_c('div',{staticClass:"wp"},[_c('Footer')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }